/**
 * Offline add-on gate.
 *
 * The offline engine runs below React (runtime.js has no store access), so the
 * `offline` add-on state is mirrored into localStorage whenever the add-ons
 * catalog is successfully fetched. The flag is only written on success: a failed
 * fetch (typically because the device is offline) must not disable the engine.
 */
export const OFFLINE_ADDON_ID = 'offline';
const FLAG_KEY = 'offlineAddonActive';

/** Mirrors the `offline` add-on state from a freshly fetched add-ons catalog. */
export function syncOfflineAddonFlag(addons) {
  const addon = (addons || []).find((item) => item?.id === OFFLINE_ADDON_ID);
  try {
    localStorage.setItem(FLAG_KEY, addon?.businessState?.uiState === 'active' ? '1' : '0');
  } catch (_) {}
}

export function isOfflineAddonActive() {
  try {
    return localStorage.getItem(FLAG_KEY) === '1';
  } catch (_) {
    return false;
  }
}
